import React from 'react'; 

export function FieldLink(rowData) {
	
	let id = rowData.fieldId;
	let link = rowData.link;
	
	return (<a href={link} target="_blank">{rowData.inputText} <i className="fas fa-external-link-alt" aria-hidden="true"></i></a>);
}
